import type { WatchSource } from 'vue'

import { isNuxtServer } from '~/utils/context'

export const untilNotEmptyClient = <T>(
  reactiveVar: MaybeRefOrGetter<T[]> | WatchSource<T[]>,
  cb: () => Promise<void> | void,
) => {
  ;(async () => {
    if (isNuxtServer()) return
    await until<T[]>(reactiveVar).toMatch((v) => v.length > 0)
    await cb()
  })()
}

export const untilNotNullClient = <T>(
  reactiveVar: MaybeRefOrGetter<T> | WatchSource<T>,
  cb: () => Promise<void> | void,
) => {
  ;(async () => {
    if (isNuxtServer()) return
    await until<T>(reactiveVar).not.toBe(null)
    await cb()
  })()
}
